import React from 'react';
import MVVM from '../../assets/MVVM.bmp';
import './gestdent.css';

const Architecture = () => {
  return (
    <section id="Architecture" className="container">
      {/* ------------------------------- architecture ------------------------------------------ */}
      <h2>Functional Architecture</h2>
      <div className="obj">
        <p>&nbsp;&nbsp;&nbsp;&nbsp;This Figure illustrates the Model-View-ViewModel (MVVM) architecture, which is a widely used software design pattern, particularly in applications with a user interface. This pattern aims to clearly separate the responsibilities and roles of different components within an application, including business logic, user interface presentation, and data management.</p>
      </div>
      <ul>
        <li><strong>Model </strong>: &nbsp;&nbsp;Represents the data and the business logic of the application. It is responsible for data retrieval, storage, and processing.</li>
        <li><strong>View </strong>: &nbsp;&nbsp;Represents the user interface. It displays the data provided by the ViewModel and sends user commands to the ViewModel.</li>
        <li><strong>ViewModel </strong>: &nbsp;&nbsp;Acts as an intermediary between the Model and the View. It handles the presentation logic and ensures that the View has the data it needs in the appropriate format.</li>
      </ul>
      <div className="mvvm-img">
        <img src={MVVM} alt="logo" />
      </div>


    </section>
  );
};

export default Architecture;
